import cn from 'classnames';
import s from './Divider.module.less';

type Props = { className?: string };
const Divider = ({ className }: Props) => <hr className={cn(s.divider, className)} />;

export default Divider;
